import { faInfo, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Typography } from "@mui/material"

function NoDataCard() {

    return (
        <Box sx={{
            p: 4,
            textAlign: 'center',
            border: `1px dashed gray`,
            borderRadius: 2,
            backgroundColor: 'background.default'

        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2
            }}>
                <FontAwesomeIcon icon={faInfo} />
                {/* <DescriptionOutlined sx={{
                                  fontSize: 48,
                                  color: 'text.disabled'
                                }} /> */}
                <Typography variant="h6" color="text.secondary">
                    No  data available
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    If filters are available, apply them to view the data.
                </Typography>
            </Box>
        </Box>
    )
}
export default NoDataCard